import React from 'react'
import { Box, Stack, Link, Typography, Grid2 as Grid, Divider, List, ListItem, ListItemText, Button } from '@mui/material'
import { AccordionSummary, AccordionDetails } from '@mui/material'
import CustomAccordion from '../../components/Accordian/accordian';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useLocation } from 'react-router-dom';
import { useGetDealByidQuery } from '../../api/endpoints/apiConfig';
import { useNavigate } from 'react-router-dom';
import { Promotion } from '../../models/Promotions';
import { UnitPriceGroupPromotion } from '../../models/AvailableUnits';
import './../../assets/styles/dashboardpage.css';

type Props = {}

const ReservationConfirmation = (props: Props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { setdata } = location.state || {};
    const { data: responseData, refetch } = useGetDealByidQuery({ facilityid: setdata?.FacilityId, dealsid: parseInt(setdata?.Dealid) });
    const formatPhoneNumber = (phone: string): string => {
        if (phone.length < 10) return 'Invalid Number'; // Check for valid phone number length
        return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    };
    const facilityData = JSON.parse(sessionStorage.getItem('facilityData') || '[]');
    const facilityPromotions: Promotion[] = facilityData[0]?.promotions || [];
    const unitPromotions: UnitPriceGroupPromotion[] = setdata?.promotions || [];
    const dealPromoId =
        responseData?.external_promotion_id != null && String(responseData.external_promotion_id).trim() !== ''
            ? String(responseData.external_promotion_id).trim()
            : String(setdata?.external_promotion_id ?? '').trim();
    const promotionName =
        facilityPromotions.find((promo) => String(promo.external_id ?? '').trim() === dealPromoId)?.name
        || unitPromotions.find((promo) => String(promo.id ?? '').trim() === dealPromoId)?.name
        || setdata?.promotion
        || '';
    const handleNavigate = () => {
        refetch();
        navigate(`/ManageReservation/${setdata?.FacilityId}/${responseData?.external_id}`);
    };
    const handleRentNavigate = () => {
        refetch();
        const rentalData = {
            unitSize: responseData?.unit_dimensions,
            features: setdata?.features,
            rent: setdata?.price,
            promotion: promotionName || 'No Promo',
            facilityId: responseData?.facility_id,
            externalUnitId: responseData?.external_unit_id,
            external_promotion_id: responseData?.external_promotion_id || setdata?.external_promotion_id,
            price_formatted: setdata?.price_formatted,
            dealId: responseData?.external_id,
            externalId: responseData?.external_id,
            firstname: responseData?.first_name,
            lastname: responseData?.last_name,
            phone: responseData?.phone,
            email: responseData?.email,
            moveInDate: responseData?.move_in_date,
            external_id: responseData?.external_id,
            rents: responseData?.quoted_price,
              address: responseData?.address,
            // address2: responseData?.address2,
            //city: responseData?.city,
            //state: responseData?.state,
            label: "convert"
        };
        navigate(`/rent/${responseData?.facility_id}/deal/${responseData?.external_id}`, {
            state: { rentalData }
        });
    };
    const handleBackToFacility = async () => {
        await refetch(); // Fetch the latest data before navigating
        navigate(`/Dashboard/${setdata?.FacilityId}`);
    };
    return (
        <>
            <Box my={2}>
                {/* /<CallScript /> */}
            </Box>
            {/* Confirmation details */}
            <Box my={2}>
                <CustomAccordion defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <Typography variant="h3" color="text.secondary">Reservation Confirmation
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Stack direction={'row'} spacing={2} flexWrap={'wrap'} useFlexGap>
                            <Box flex={1}>
                                <Typography mb={2} variant='h3' color='text.secondary'>Tenant Information</Typography>
                                <Grid container spacing={0.5} columns={12}>
                                    <Grid size={6}>
                                        <List>
                                            <ListItem>
                                                <ListItemText primary='First Name' secondary={responseData?.first_name} />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                    <Grid size={6}>
                                        <List>
                                            <ListItem>
                                                <ListItemText primary='Last Name' secondary={responseData?.last_name} />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                    <Grid size={6}>
                                        <List>
                                            <ListItem>
                                                <ListItemText primary='Phone Number' secondary={responseData?.phone ? formatPhoneNumber(responseData.phone) : 'N/A'} />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                    <Grid size={6}>
                                        <List>
                                            <ListItem>
                                                <ListItemText primary='email' secondary={responseData?.email} />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Divider orientation='vertical' flexItem />
                            <Box flex={1}>
                                <Typography mb={2} variant='h3' color='text.secondary'>Reservation Information</Typography>
                                <Grid container spacing={0.5} columns={12}>
                                    <Grid size={4}>
                                        <List>
                                            <ListItem>
                                                <ListItemText primary='Type ' secondary={responseData?.type} />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                    <Grid size={4}>
                                        <List>
                                            <ListItem>
                                                <ListItemText primary='Unit Size' secondary={`${setdata.width > 0 ? setdata.width + "' x " + setdata.length + "'" : setdata.length + "'"}`} />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                    <Grid size={4}>
                                        <List>
                                            <ListItem>
                                                <ListItemText primary='Monthly Rent' secondary={`$${responseData?.quoted_price.toFixed(2)}`} />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                    <Grid size={4}>
                                        <List>
                                            <ListItem>
                                                <ListItemText primary='Promotion' secondary={promotionName?.trim() ? promotionName : "No Promo"}  />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                    <Grid size={4}>
                                        <List>
                                            <ListItem>
                                                <ListItemText primary='Move-In Date' secondary={responseData?.move_in_date ? new Date(responseData.move_in_date).toLocaleDateString(undefined, {
                                                    year: 'numeric',
                                                    month: 'short',
                                                    day: 'numeric',
                                                    timeZone: 'UTC',
                                                }) : 'N/A'} />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                    <Grid size={4}>
                                        <List>
                                            <ListItem>
                                                <ListItemText primary='Follow-Up Date' secondary={responseData?.followup_at ? new Date(responseData.followup_at).toLocaleDateString(undefined, {
                                                    year: 'numeric',
                                                    month: 'short',
                                                    day: 'numeric',
                                                    timeZone: 'UTC',
                                                }) : 'N/A'} />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Stack>

                    </AccordionDetails>
                </CustomAccordion>
            </Box>
            <Box my={4}>
                <Stack direction={'row'} spacing={2} useFlexGap justifyContent={{ xs: 'start', sm: 'end' }}>
                    <Link
                        onClick={handleRentNavigate}
                        className="modify-link"
                    >
                        Convert
                    </Link>
                    <Link
                        onClick={handleNavigate}
                        className="modify-link"
                    >
                        Modify
                    </Link>
                    <Button
                        sx={{ marginRight: 2 }}
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={handleBackToFacility}
                    >
                        Back To Facility
                    </Button>

                </Stack>
            </Box>
        </>
    )
}

export default ReservationConfirmation
